import { render, staticRenderFns } from "./AdminDeliveryAdviceFilters.vue?vue&type=template&id=63b44573"
import script from "./AdminDeliveryAdviceFilters.vue?vue&type=script&lang=js"
export * from "./AdminDeliveryAdviceFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports